<template>
  <nav>
      <v-app-bar flat app>
          <v-app-bar-nav-icon class="grey--text" @click="drawer = !drawer"></v-app-bar-nav-icon>
          <v-app-bar-title  class="text-uppercase grey--text">
              <span>CRM</span>

          </v-app-bar-title>
          <v-spacer></v-spacer>
          
      </v-app-bar>
      <v-navigation-drawer v-model="drawer" app class="indigo">
          <v-list>
              <v-list-item v-for="link in adashlinks" :key="link.text" router :to="link.route">
                  <v-list-item-action>
                      <v-icon class="white--text">{{link.icon}}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                      <v-list-item-title class="white--text">
                          {{link.text}} 
                      </v-list-item-title>
                  </v-list-item-content>
              </v-list-item>
          </v-list>
      </v-navigation-drawer>
  </nav>
        
</template>

<script>
export default{
    data(){
        return {
            PageTitle: 'CRM',
            drawer: false,
            //curprofile: localStorage.getItem("CURPROFILE"),
            adashlinks:[
                {icon: 'dashboard', text: 'Dashboard', route: '/Dashboard'},
                {icon: 'business', text: 'Companies', route: '/Companies'},
                {icon: 'people', text: 'Audiences', route: '/Audiences'},
                {icon: 'list', text: 'Activities', route: '/Activities'},
                {icon: 'settings', text: 'Settings', route: '/Settings'},
                {icon: 'exit_to_app', text: 'Sign Out', route: '/Signout'},

            ]

        }
    } 
   
}
</script>
